import { useState } from "react";

function Container(props) {
    const [className, setClassName] = useState("container " + props.className);

    return (
        <div className={className}>{props.children}</div>    
    );
}

export default Container;
